import styled from "styled-components";

export const Container = styled.div`
  padding-top: 20px; 
`;

export const Headline = styled.p`
  font-weight: 600;
  margin-bottom: 16px;
  float: left;
`;

export const Description = styled.p`
`;

export const ProductRow = styled.div`
  display: flex;
  justify-content: space-between;
  clear: both;
`;

export const UnionAndInsurance = styled.div`
  float: left;
  font-size: 18px;
  margin-bottom: 24px;
  line-height: 1.3em;
`; 

export const Product = styled.p`
 span {
  margin-top: -1px;
 }
`;

export const ProductHeadline = styled.p`
  font-size: 14px;
  margin-bottom: 8px;
`;

export const ProductFree = styled.p`
  margin-bottom: 0px;
  float: right;
`;

export const ProductFreeExtra = styled.p`
  font-size: 12px;
  font-style: italic;
  text-align: end;
`;

export const ProductExtra = styled.p`
  text-align: end;
`;

export const ProductRowHeadline = styled.p`
  font-weight: 600;
  font-size: 14px;
  margin: 8px 0px 4px 0px;
`;

export const Sumup = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #c9c9c9;
  border-bottom: 1px solid #c9c9c9;
  margin-top: 8px;
`;

export const SumupText = styled.p`
    font-weight: 600;
    margin-bottom: 0px;
    padding: 7px 0px;
}
`;

export const Info = styled.p`
  margin: 15px 0px;
  font-size: 14px;
`;

export const ProductrowSalaryinsuranceUnion = styled.div`
  display flex;
  justify-content: space-between;
  align-items: end;
`;

export const SalaryinsuranceUnionSpan = styled.span`
display block;
@media (min-width: 768px) {
  display: inline-block; 
}
`;

export const OLlist = styled.ol`
  padding-left: 1.5em;
  margin-bottom: 0px;
  line-height: 1.3em;
  font-size: 14px;
  list-style: dicimal;
`;

export const LIlist = styled.li`
  font-sixe: 14px;
  margin-bottom: 12px; 
  line-height: 1.3em;
  &::marker {
    font-weight: 600;
  }
`;

export const InfoText = styled.p`
  font-size: 12px;
  color: rgb(107, 107, 106);
  font-style: italic;
  margin: 13px 0px 0px 0px;
`;
